import { reactive } from 'vue';

const toastState = reactive({
    show: false,
    message: '',
    type: 'info',
    duration: 4000
});

export function useToast() {
    const showToast = (message, type = 'info', duration = 4000) => {
        toastState.message = message;
        toastState.type = type;
        toastState.duration = duration;
        toastState.show = true;
    };

    const hideToast = () => {
        toastState.show = false;
    };

    return {
        toastState,
        showToast,
        hideToast
    };
}
